/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Credittopupshortfall3Inputs */

const en_credittopupshortfall3 = /** @type {(inputs: Credittopupshortfall3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You're ${i?.credits} credits short. Pick how many to add.`)
};

const de_credittopupshortfall3 = /** @type {(inputs: Credittopupshortfall3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dir fehlen ${i?.credits} Credits. Wähl, wie viele du dazunehmen willst.`)
};

/**
* | output |
* | --- |
* | "You're {credits} credits short. Pick how many to add." |
*
* @param {Credittopupshortfall3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const credittopupshortfall3 = /** @type {((inputs: Credittopupshortfall3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Credittopupshortfall3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_credittopupshortfall3(inputs)
	return de_credittopupshortfall3(inputs)
});
export { credittopupshortfall3 as "creditTopUpShortfall" }